 import axios from '../../apis/Api.js'

 export const VerifyUserForUpdatePassword = (updatePasswordToken) => async () => {
   return await axios.get(`api/Authenticate/VerifyUserForUpdatePassword?updatePasswordToken=`+updatePasswordToken);
 }

  export const UpdateUserPasswordThroughEmail = (requestData) => async () => {
   return await axios.post(`api/Authenticate/UpdateUserPasswordThroughEmail`, requestData);
 }